import { createFont } from "@tamagui/core";

const size = {
  0.8: 10,
  1: 12,
  2: 14,
  3: 16,
  4: 18,
  5: 20,
  6: 24,
  6.8: 32,
  7: 34,
  7.3: 40,
  8: 44,
  9: 60,
};

const weight = {
  3: "300",
  4: "400",
  5: "500",
  6: "600",
  7: "700",
};

const getLineHeight = (lineHeight: number) =>
  Object.fromEntries(Object.entries(size).map(([k, v]) => [k, lineHeight * v]));

export const fonts = {
  body: createFont({
    family: "Fixel Text",
    size,
    letterSpacing: {},
    weight,
    lineHeight: {
      ...getLineHeight(1.5),
    },
  }),

  subtitle: createFont({
    family: "Fixel Text",
    size,
    lineHeight: {
      ...getLineHeight(1.2),
    },
    weight,
  }),

  heading: createFont({
    family: "Fixel Text",
    size,
    letterSpacing: {},
    lineHeight: {
      ...getLineHeight(1.2),
    },
    weight,
  }),

  howareu: createFont({
    family: "PF Regal Text Pro",
    size,
    letterSpacing: {},
    lineHeight: {
      ...getLineHeight(1.2),
    },
    wight: {
      4: "400",
    },
  }),
};
